import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from "react-i18next";

const FilteringSelect = ({ options, value, onChange, label, name, id, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [displayValue, setDisplayValue] = useState('');
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  const filteredOptions = options.filter(option => 
    option.countryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOption = options.find(option => option.countryCode === value);

  useEffect(() => {
    if (selectedOption) {
      setDisplayValue(selectedOption.countryName);
    } else {
      setDisplayValue('');
    }
  }, [selectedOption]);

  useEffect(() => {
    if (isOpen) {
    } else {
      setSearchTerm('');
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true); 
  };

  const handleOptionClick = (option) => {    
    setDisplayValue(option.countryName);
    onChange({ target: { name, value: option.countryCode } });
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div 
      className={` az-formfield--select ${isOpen ? 'az-formfield--open' : ''}`} 
      ref={dropdownRef}
    >
      <label className={`az-formfield__select-label ${displayValue ? 'hasValue' :'' } ${disabled ? 'disabled' : ''} `}>
        {t(label)}
      </label>

      <input
        type="text"
        className="az-formfield__select"
        placeholder=" "
        value={isOpen ? searchTerm : displayValue}
        onChange={handleInputChange}
        onClick={handleInputClick}
        disabled={disabled}
        readOnly={!isOpen}
      />
      
    
      <div className="az-formfield__select-arrow" onClick={handleInputClick}>
        <img 
          src={disabled ? process.env.PUBLIC_URL + 'images/arrow-down-disabled.png': process.env.PUBLIC_URL + 'images/arrow-down.png'}
          alt="arrow-down"
        />
      </div>

      {isOpen && (
        <div className="az-formfield__select-dropdown">
          <ul className="az-formfield__select-options">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li
                  key={option.countryCode}
                  className={`az-formfield__select-option ${option.countryCode === value ? 'az-formfield__select-option--active' : ''}`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.countryName}
                </li>
              ))
            ) : (
              <li className="az-formfield__select-option az-formfield__select-option--empty" >
                {t('buyerSearch.country.noResult')}
              </li>
            )}
          </ul>
        </div>
      )}
      
      <input
        type="hidden"
        id={id}
        name={name}
        value={value || ''}
      />
    </div>
  );
};

export default FilteringSelect;